import { Brand as TypeBrand, createBranded } from '@deltasierra/type-utilities';
import { HasId, FullAuditable, ObjectOrVoid, PathBuilder, ApiRoute, HttpMethod } from '../common';
import { UserId } from '../user/User';

export type DeviceOS = 'android' | 'ios';

export interface Device extends HasId<DeviceId>, FullAuditable {
    deviceUID: string;
    token: string | null;
    os: DeviceOS | null;
    endpointARN: string | null;
    currentUserId: UserId | null;
}

export interface DeviceIdentifier {
    uid: string;
}

export interface RegisterDeviceInfo extends DeviceIdentifier {
    token: string | null;
    os: DeviceOS;
}

export interface UserDevicesStatus {
    hasDevice: boolean;
    notificationsEnabled: boolean;
}

const DEVICES_API_ROOT = <T extends ObjectOrVoid>(path: PathBuilder<T>) => path.literal('devices');

export const DeviceApi = {
    getUserDeviceStatus: new ApiRoute<UserDevicesStatus, { id: UserId }, void, void>(HttpMethod.Get, path =>
        DEVICES_API_ROOT(path).literal('user').param('id').literal('status'),
    ),
    logoutDevice: new ApiRoute<void, void, DeviceIdentifier, void>(HttpMethod.Post, path =>
        DEVICES_API_ROOT(path).literal('logout'),
    ),
    registerDevice: new ApiRoute<Device, void, RegisterDeviceInfo, void>(HttpMethod.Post, path =>
        DEVICES_API_ROOT(path).literal('register'),
    ),
};

export type DeviceId = TypeBrand<number, 'DeviceId'>;
export const DeviceId = createBranded<DeviceId>();
